import { select, put } from 'redux-saga/effects'
import createAction from 'loankeeper-common/helpers/createAction'

import { getPermissions } from '../../../store/permissions'
import { dataExistsOrIsBeingFetched, getAllActiveTabData } from '../selectors'
import { actions } from '../constants'

export function* fetchIfNotExists(args, meta) {
  // ID in payload can be different from ID in meta
  // So always overwrite payload's ID with meta
  // meta contains only type & ID
  const cond = yield select(dataExistsOrIsBeingFetched, { type: meta.type, ID: meta.ID, page: args.page })

  if (!cond || args.page === args.needsFreshData) {
    delete args.needsFreshData // eslint-disable-line

    yield put(createAction(actions.data.FETCH, args, meta))
  }
}

function isAllowedToFetchPage(requestObject, permissions) {
  if (typeof requestObject.permission === 'string') {
    return permissions[requestObject.permission]
  }

  if (typeof requestObject.permission === 'function') {
    return requestObject.permission(permissions)
  }

  if (Object.hasOwnProperty.call(requestObject, 'fetchOnInit')) {
    return requestObject.fetchOnInit
  }

  return true
}

export default function* switchTab({ payload, meta }) {
  const permissions = yield select(getPermissions)

  let {
    tab: { needsFreshData, api, getTabInitialParams },
    ID,
    hash,
  } = payload

  const allTabData = yield select(getAllActiveTabData, { type: meta.type, ID: meta.ID })

  if (!Array.isArray(api)) {
    api = [api]
  }

  if (!Array.isArray(getTabInitialParams)) {
    getTabInitialParams = [getTabInitialParams]
  }

  for (let i = 0; i < api.length; i++) {
    const additionalParams = getTabInitialParams && getTabInitialParams[i] ? getTabInitialParams[i](allTabData) : {}

    let requestObject = api[i]

    if (typeof requestObject !== 'string') {
      if (!isAllowedToFetchPage(requestObject, permissions)) {
        continue // eslint-disable-line
      }

      requestObject = requestObject.page
    }

    yield* fetchIfNotExists(
      {
        ID,
        hash,
        needsFreshData,
        ...additionalParams,
        page: requestObject,
      },
      meta,
    )
  }
}
